import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Renderer2,
} from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
	selector: 'app-terms',
	standalone: true,
	imports: [
		NavbarComponent,
		FooterComponent,
		TranslocoPipe
	],
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.css'],
})
export class TermsComponent implements OnInit {
	@ViewChild('sidebarWrapper') private el: ElementRef;
	navbarType = 'other';

	constructor(public element: ElementRef, public renderer: Renderer2) { }

	ngOnInit() {
	}

}
